import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=d72d2930&scoped=true&"
import script from "./EventManagement.vue?vue&type=script&lang=js&"
export * from "./EventManagement.vue?vue&type=script&lang=js&"
import style0 from "./EventManagement.vue?vue&type=style&index=0&id=d72d2930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72d2930",
  null
  
)

export default component.exports